import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const hiringsAdapter = createEntityAdapter({})

const initialState = hiringsAdapter.getInitialState()

export const hiringApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getHirings: builder.query({
            query: () => ({
                url: '/hiring',
                method: 'GET',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),

            transformResponse: responseData => {
                const loadedHirings = responseData.map(hiring => {
                    hiring.id = hiring._id
                    return hiring
                });
                return hiringsAdapter.setAll(initialState, loadedHirings)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Hiring', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Hiring', id }))
                    ]
                } else return [{ type: 'Hiring', id: 'LIST' }]
            }
        }),
        addNewHiring: builder.mutation({
            query: initialHiringData => ({
                url: '/hiring',
                method: 'POST',
                body: {
                    ...initialHiringData,
                }
            }),
            invalidatesTags: [
                { type: 'Hiring', id: "LIST" }
            ]
        }),
        updateHiring: builder.mutation({
            query: initialHiringData => ({
                url: '/hiring',
                method: 'PATCH',
                body: {
                    ...initialHiringData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Hiring', id: arg.id }
            ]
        }),
        deleteHiring: builder.mutation({
            query: ({ id }) => ({
                url: `/hiring`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Hiring', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetHiringsQuery,
    useAddNewHiringMutation,
    useUpdateHiringMutation,
    useDeleteHiringMutation,
} = hiringApiSlice

// returns the query result object
export const selectHiringsResult = hiringApiSlice.endpoints.getHirings.select()

// creates memoized selector
const selectHiringsData = createSelector(
    selectHiringsResult,
    hiringsResult => hiringsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllHirings,
    selectById: selectHiringById,
    selectIds: selectHiringIds
    // Pass in a selector that returns the users slice of state
} = hiringsAdapter.getSelectors(state => selectHiringsData(state) ?? initialState)